<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import TableLoading from "@/components/ipos/table-loading";
import appConfig from "@/app.config";
import Multiselect from "vue-multiselect";
import UtilsMixin from "@/mixins/utils";
import DatePicker from "vue2-datepicker";
import { brandService } from "@/services/authservice/brand";
import { itemService } from "@/services/authservice/item";
import { promotionService } from "@/services/authservice/promotion";
import { base } from "@/services/base";
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import PictureInput from "vue-picture-input";
import { commonService } from "@/services/common";
import  { listPromotionApplyType } from '@/services/constant'
export default {
  page: {
    title: "Chi tiết chương trình giảm giá của nhãn hàng",
    meta: [{ name: "description", content: appConfig.description }],
  },
  mixins: [UtilsMixin],
  components: {
    Layout,
    PageHeader,
    TableLoading,
    Multiselect,
    DatePicker,
    ckeditor: CKEditor.component,
    PictureInput,
  },
  data() {
    return {
      listBrand: [],
      listItemAll: [],
      listItem: [],
      listChannel: [],
      listItemOrigin: [],
      listTypeExtra: [
        { id: "PER_ORDER", name: "Chiết khấu toàn đơn" },
        { id: "PER_ITEM", name: "Giảm giá mặt hàng" },
        { id: "CUSTOMIZE", name: "Chương trình khác" },
      ],
      listType: [
        { id: "AMOUNT_BILL", name: "Tổng tiền đơn hàng" },
        { id: "AMOUNT", name: "Tổng tiền mặt hàng" },
        { id: "QUANTITY", name: "Số lượng" },
      ],
      listDiscountType: [
        { id: "PERCENTAGE", name: "Giảm giá phần trăm" },
        { id: "MONEY_REDUCTION", name: "Giảm tiền" },
        { id: "PRICE_REDUCTION", name: "Giảm giá bán" },
        { id: "ITEM_DONATION", name: "Tặng hàng hoá" },
        { id: "PERCENTAGE_DONATION", name: "Giảm giá % + Tặng hàng" },
        { id: "MONEY_REDUCTION_DONATION", name: "Giảm tiền + Tặng hàng" },
        { id: "PERCENTAGE_OR_DONATION", name: "Giảm giá % hoặc Tặng hàng" },
        { id: "MONEY_REDUCTION_OR_DONATION", name: "Giảm tiền hoặc Tặng hàng" },
      ],
      listDiscountTypeForAmountBill: [
        { id: "PERCENTAGE", name: "Giảm giá phần trăm" },
        { id: "MONEY_REDUCTION", name: "Giảm tiền" },
      ],
      listGiftType: [
        { id: "OR", name: "Tặng hàng hoá A hoặc B" },
        { id: "AND", name: "Tặng hàng hoá A và B" },
        { id: "BOTH", name: "Tặng hàng hóa A và B hoặc C và D" },
      ],
      listPromotionApplyType,
      title: "Chi tiết chương trình giảm giá của nhãn hàng",
      items: [
        {
          text: "Trang chủ",
          href: "/",
        },
        {
          text: "Khuyến mãi",
          active: true,
        },
        {
          text: "Giảm giá của nhãn hàng",
          active: true,
        },
      ],
      isBtnLoading: false,
      isEdit: false,
      formData: {
        id: "",
        channel: "",
        name: "",
        imageUrl: "",
        date: "",
        brand: "",
        promotionTypeExtra: "",
        promotionValidId: "",
        promotionApplyType: ""
      },
      formRule: {
        item: [],
        levelType: "",
        fromLevel: "",
        toLevel: "",
        discountType: "",
        discountRate: "",
        itemGift: [],
        listGiftSelected: [],
        giftType: { id: "OR", name: "Tặng hàng hoá A hoặc B" },
        listRuleGift: [{ name: "Nhóm 1", itemGift: [], listGiftSelected: [] }],
        discountRateMax: null,
      },
      listRule: [],
      isBusy: false,
      me: {},
      fileImport: null,
      step: 1,
      tabCheck: 1,
      listError: [],
      listSuccess: [],
      isLoadingCheck: false,
      editor: ClassicEditor,
      editorData: "",
      detailData: {},
      isApproveAll: false,
    };
  },
  beforeMount() {
    this.me = JSON.parse(localStorage.getItem("user"));
    this.getInitData();
  },
  computed: {
    showApplyType(){
      return this.formData.promotionTypeExtra && this.formData.promotionTypeExtra.id === 'PER_ORDER'
    }
  },
  methods: {
    resetHideFormRule() {
      this.formRule = {
        item: [],
        levelType: "",
        fromLevel: "",
        toLevel: "",
        discountType: "",
        discountRate: "",
        itemGift: [],
        listGiftSelected: [],
        giftType: { id: "OR", name: "Tặng hàng hoá A hoặc B" },
        listRuleGift: [{ name: "Nhóm 1", itemGift: [], listGiftSelected: [] }],
        discountRateMax: null,
      };
      this.fileImport = null;
      this.step = 1;
      this.tabCheck = 1;
      this.listError = [];
      this.listSuccess = [];
      this.isLoadingCheck = false;
      this.$bvModal.hide("md-crud");
      this.$bvModal.hide("md-import");
    },

    async getInitData() {
      this.isBusy = true;
      // get list item
      // const resItem = await itemService.getList({ active: 1 });
      // resItem.data.data
      //   ? (this.listItemAll = resItem.data.data)
      //   : (this.listItemAll = []);
      // get list brand
      const resBrand = await brandService.getList();
      resBrand.data.data
        ? (this.listBrand = resBrand.data.data)
        : (this.listBrand = []);

      // get list sale channel
      const resChannel = await commonService.getListSaleChannel();
      this.listChannel = resChannel.data.data;

      await this.getDetailData();
      this.isBusy = false;
    },

    async getDetailData() {
      const resDetail = await promotionService.getListPromotion({
        uid: this.$route.params.id,
      });
      if (resDetail.data.data) {
        this.detailData = resDetail.data.data;
        // get list item
        const resItem = await itemService.getList({
          active: 1,
          trademark_uid: this.detailData.trademark_uid,
        });
        resItem.data.data
          ? (this.listItemAll = resItem.data.data)
          : (this.listItemAll = []);
        this.listItem = this.listItemAll
        this.listItemOrigin = this.listItemAll
        this.formData.name = this.detailData.promotion_name;
        this.formData.imageUrl = this.detailData.image_url;
        this.formData.channel =
          this.detailData.list_sale_channel.length > 0
            ? this.detailData.list_sale_channel
            : this.listChannel.filter((e) => e.channel_id === "ALL");
        this.editorData = this.detailData.description;
        this.formData.date = [
          new Date(this.detailData.from_date),
          new Date(this.detailData.to_date),
        ];
        this.formData.brand = this.listBrand.find(
          (e) => e.id === this.detailData.trademark_uid
        );
        this.formData.promotionValidId = this.detailData.promotion_valid_id;
        this.formData.promotionTypeExtra = this.listTypeExtra.find(
          (e) => e.id === this.detailData.promotion_type_extra
        );
        this.formData.promotionApplyType = this.listPromotionApplyType.find((e)=> e.id === this.detailData.promotion_apply_type)
        if (!this.formData.promotionTypeExtra)
          this.formData.promotionTypeExtra = {
            id: "PER_ITEM",
            name: "Giảm giá mặt hàng",
          };
        this.listRule = this.detailData.list_rule.map((e) => {
          if (e.list_item.length > 0) {
            this.isApproveAll = false;
            return {
              id: e.id,
              discountRate: e.discount_rate,
              discountType: e.discount_type,
              item: e.list_item,
              levelType: e.level_type,
              fromLevel: e.from_level,
              toLevel: e.to_level,
              itemGift: e.item_donation ? e.item_donation.details : [],
              listGiftSelected: e.item_donation ? e.item_donation.details : [],
              giftType: e.item_donation ? e.item_donation.type : "",
              listRuleGift:
                e.item_donation && e.item_donation.list_rule
                  ? e.item_donation.list_rule.map((e) => {
                      return {
                        name: e.name,
                        itemGift: e.details,
                        listGiftSelected: e.details,
                      };
                    })
                  : [],
              status: e.status,
              original_data: e,
              discountRateMax: e.discount_rate_max,
            };
          } else {
            this.isApproveAll = true;
            return {
              id: "ALL",
              discountRate: e.discount_rate,
              discountType: e.discount_type,
              item: e.list_item,
              levelType: e.level_type,
              fromLevel: e.from_level,
              toLevel: e.to_level,
              itemGift: e.item_donation ? e.item_donation.details : [],
              listGiftSelected: e.item_donation ? e.item_donation.details : [],
              giftType: e.item_donation ? e.item_donation.type : "",
              listRuleGift: e.item_donation
                ? e.item_donation.list_rule.map((e) => {
                    return {
                      name: e.name,
                      itemGift: e.details,
                      listGiftSelected: e.details,
                    };
                  })
                : [],
              status: "CONFIRMED",
              discountRateMax: e.discount_rate_max,
            };
          }
        });
      } else {
        this.detailData = {};
      }
    },

    handleAddItem(type) {
      if (this.formData.brand && this.formData.date) {
        if (type === "add") {
          if (this.formData.promotionTypeExtra.id === "PER_ORDER") {
            this.listType = [{ id: "AMOUNT_BILL", name: "Tổng tiền đơn hàng" }];
            this.formRule.levelType = {
              id: "AMOUNT_BILL",
              name: "Tổng tiền đơn hàng",
            };
            if (this.listRule.length > 0) {
              if (this.detailData.status === "CONFIRMED") {
                if (this.listRule.find((e) => e.status === "CONFIRMED")) {
                  this.$notify({
                    group: "app",
                    type: "warn",
                    title: "Chỉ có thể tạo 1 rule chương trình",
                    text: "Vui lòng hủy rule hiện tại và tạo lại rule mới",
                  });
                } else {
                  this.$bvModal.show("md-crud");
                }
              } else {
                this.$notify({
                  group: "app",
                  type: "warn",
                  title: "Chỉ có thể tạo 1 rule chương trình",
                  text: "Vui lòng xóa rule hiện tại và tạo lại rule mới",
                });
              }
            } else {
              this.$bvModal.show("md-crud");
            }
          }
          if (this.formData.promotionTypeExtra.id === "PER_ITEM") {
            this.listType = [
              { id: "AMOUNT", name: "Tổng tiền mặt hàng" },
              { id: "QUANTITY", name: "Số lượng" },
            ];
            this.$bvModal.show("md-crud");
          }
          this.updateListItem();
        } else {
          this.$bvModal.show("md-import");
        }
      } else {
        this.$notify({
          group: "app",
          type: "warn",
          text: "Vui lòng chọn thời gian và nhãn hàng",
        });
      }
    },

    async onAddRule() {
      if (this.formRule.item.length > 0) {
        if (this.detailData.status === "PENDING") {
          // nếu status là pending thì cho thêm nhiều
          const strSku = this.formRule.item.map((e) => e.sku).join(",");
          // this.formRule.item.forEach((e) => {
          this.listRule.push({
            id: strSku,
            item: this.formRule.item,
            levelType: this.formRule.levelType.id,
            fromLevel: this.formRule.fromLevel,
            toLevel: this.formRule.toLevel,
            discountRate: this.formRule.discountRate,
            discountType: this.formRule.discountType.id,
            itemGift: this.formRule.itemGift,
            listGiftSelected: this.formRule.listGiftSelected,
            giftType: this.formRule.giftType.id,
            listRuleGift: this.formRule.listRuleGift,
            status: "NEW_ADD",
            discountRateMax:
              this.formRule.discountRateMax &&
              this.formRule.levelType.id === "AMOUNT_BILL"
                ? this.parseCurrency(this.formRule.discountRateMax)
                : null,
          });
          // });
          this.$bvModal.hide("md-crud");
          this.updateListItem();
        } else {
          // nếu status là confirmed thì cho thêm từng sp 1
          let obj = {
            promotion_uid: this.detailData.id,
            trademark_uid: this.detailData.trademark_uid,
            from_date: this.detailData.from_date,
            to_date: this.detailData.to_date,
            from_level:
              this.formRule.fromLevel && this.formRule.fromLevel !== ""
                ? parseFloat(this.formRule.fromLevel)
                : null,
            to_level:
              this.formRule.toLevel && this.formRule.toLevel !== ""
                ? parseFloat(this.formRule.toLevel)
                : null,
            level_type: this.formRule.levelType.id,
            discount_rate:
              this.formRule.discountRate && this.formRule.discountRate !== ""
                ? parseFloat(this.formRule.discountRate)
                : 0,
            discount_type: this.formRule.discountType.id,
            list_item_uid: this.formRule.item.map((f) => f.id),
            item_donation: null,
          };

          switch (this.formRule.discountType.id) {
            case "PERCENTAGE":
              if (this.formRule.levelType.id === "AMOUNT_BILL") {
                obj.discount_rate_max = this.formRule.discountRateMax
                  ? this.parseCurrency(this.formRule.discountRateMax)
                  : null;
              }
              break;
            // case "MONEY_REDUCTION":
            // case "PRICE_REDUCTION":
            //   break;
            case "ITEM_DONATION":
            case "PERCENTAGE_DONATION":
            case "MONEY_REDUCTION_DONATION":
            case "PERCENTAGE_OR_DONATION":
            case "MONEY_REDUCTION_OR_DONATION":
              if (this.formRule.giftType.id !== "BOTH") {
                obj = {
                  ...obj,
                  item_donation: {
                    type: this.formRule.giftType.id,
                    details: this.formRule.listGiftSelected,
                  },
                };
              } else {
                obj = {
                  ...obj,
                  item_donation: {
                    type: this.formRule.giftType.id,
                    details: [],
                    list_rule: this.formRule.listRuleGift.map((e) => {
                      return { name: e.name, details: e.listGiftSelected };
                    }),
                  },
                };
              }
              break;
          }
          const response = await promotionService.createRuleTrademark(obj);
          if (response.data.data) {
            this.$notify({
              group: "app",
              type: "success",
              text: "Thêm rule giảm giá thành công",
            });
            this.$bvModal.hide("md-crud");
            await this.getDetailData();
          } else {
            this.$notify({
              group: "app",
              type: "error",
              title: "Đã có lỗi xảy ra, vui lòng kiểm tra lại",
              text: response.data.error.message,
            });
          }
        }
      } else {
        this.$notify({
          group: "app",
          type: "warn",
          text: "Vui lòng chọn hàng hoá, điều kiện giảm giá và mức giảm giá",
        });
      }
    },

    async onChangeBrand(value) {
      this.listItem = this.listItemAll.filter(
        (e) => e.trademark_uid === value.id
      );
      this.listItemOrigin = this.listItemAll.filter(
        (e) => e.trademark_uid === value.id
      );
      this.listRule = [];
    },

    onChangeTab(id) {
      if (this.fileImport !== null) {
        this.step = id;
      }
    },

    onChangeTabCheck(id) {
      this.tabCheck = id;
    },

    async onCheckFile() {
      if (this.fileImport) {
        this.isLoadingCheck = true;
        let formData = new FormData();
        formData.append("file", this.fileImport);
        const response = await base.preImport(formData, {
          data_type: "DISCOUNT_TRADEMARK",
          trademark_uid: this.formData.brand.id,
          from_date: this.formData.date[0].setHours(0, 0, 0, 0),
          to_date: this.formData.date[1].setHours(23, 59, 59, 999),
        });
        if (response.data.error) {
          this.$notify({
            group: "app",
            type: "error",
            title: "Đã có lỗi xảy ra",
            text: response.data.error.message,
          });
        } else {
          this.listError = response.data.data.error_list;
          this.listSuccess = response.data.data.success_list;
          if (this.listError.length > 0) {
            this.tabCheck = 1;
          } else {
            this.tabCheck = 2;
          }
          this.step = 2;
        }
        this.isLoadingCheck = false;
      } else {
        this.$notify({
          group: "app",
          type: "error",
          title: "Bạn phải chọn file dữ liệu import",
        });
      }
    },

    async onImport() {
      this.listRule = this.listSuccess.map((e) => {
        let formatItem = e.list_item_uid.map((f) => {
          return this.listItemOrigin.find((g) => g.id === f);
        });
        const strSku = formatItem.map((e) => e.sku).join(",");
        return {
          id: strSku,
          discountRate: e.discount_rate,
          discountType: e.discount_type,
          item: formatItem,
          levelType: e.level_type,
          fromLevel: e.from_level,
          toLevel: e.to_level,
          itemGift: e.item_donation ? e.item_donation.details : [],
          listGiftSelected: e.item_donation ? e.item_donation.details : [],
          giftType: e.item_donation_type,
          status: "NEW_ADD",
        };
      });
      this.$bvModal.hide("md-import");
    },

    async onChangeImage() {
      let pictureInput = this.$refs.pictureInput;
      if (pictureInput.image) {
        const file = pictureInput.file;
        if (file) {
          let formData = new FormData();
          formData.append("file", file);
          const response = await base.uploadImageDMS(formData, {
            thumb_size: "200,200",
          });
          if (response.data.error) {
            this.$notify({
              group: "app",
              type: "error",
              title: "Đã có lỗi xảy ra",
              text: response.data.error.message,
            });
          } else {
            this.formData.imageUrl = response.data.data.img_url;
            this.formData.imageUrlThumb = response.data.data.img_url_thumb;
          }
        }
      } else {
        console.log("FileReader API not supported: use the <form>, Luke!");
      }
    },

    removeImage() {
      this.formData.imageUrl = "";
      this.formData.imageUrlThumb = "";
    },

    removeRule(item) {
      this.$bvModal
        .msgBoxConfirm(`Bạn có chắc chắn muốn xoá rule giảm giá này không?`, {
          title: "Xác nhận xoá rule giảm giá",
          okVariant: "primary",
          size: "sm",
          okTitle: "Đồng ý",
          cancelTitle: "Thôi",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((action) => {
          if (action) {
            this.listRule = this.listRule.filter(
              (e) => `${e.id}${e.status}` !== `${item.id}${item.status}`
            );
            this.updateListItem();
          }
        });
    },

    cancelRule(item) {
      this.$bvModal
        .msgBoxConfirm(
          `Rule giảm giá này đang chạy, bạn có chắc chắn muốn huỷ rule giảm giá này không?`,
          {
            title: "Xác nhận huỷ rule giảm giá",
            okVariant: "primary",
            size: "sm",
            okTitle: "Đồng ý",
            cancelTitle: "Thôi",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then(async (action) => {
          if (action) {
            console.log(item);
            const body = {
              id: item.original_data.id,
              status: "CANCELED",
            };
            const response = await promotionService.cancelRuleBrand(body);
            if (response.data.data) {
              this.$notify({
                group: "app",
                type: "success",
                text: "Huỷ rule giảm giá hành công",
              });
              await this.getDetailData();
            } else {
              this.$notify({
                group: "app",
                type: "error",
                title: "Đã có lỗi xảy ra, vui lòng kiểm tra lại",
                text: response.data.error.message,
              });
            }
          }
        });
    },

    updateListItem() {
      if (this.listRule.length > 0 && this.listRule[0].id === "ALL") {
        this.listItem = [];
      } else {
        let arrItem = [];
        this.listRule.forEach((e) => {
          if (e.status !== "CANCELED") {
            arrItem = arrItem.concat(e.item);
          }
        });
        const strSku = arrItem.map((e) => e.sku).join(",");
        // this.listItem = this.listItemOrigin.filter(
        //   (e) => !strSku.includes(e.sku)
        // );
        this.listItem = this.listItemOrigin.map((e) => {
          return {
            ...e,
            isRule: strSku.includes(e.sku),
          };
        });
      }
    },

    onChangeItemGift() {
      this.formRule.listGiftSelected = this.formRule.itemGift.map((e) => {
        return {
          id: e.id,
          sku: e.sku,
          item_name: e.name,
          unit_id: e.unit.unit_id,
          unit_name: e.unit.unit_name,
          donation_qty: e.donation_qty,
          trademark_uid: e.trademark_uid,
        };
      });
    },

    onChangeQuantity(value, id) {
      this.formRule.listGiftSelected = this.formRule.listGiftSelected.map(
        (obj) => {
          if (obj.id === id) {
            if (parseInt(value) > 0) {
              return { ...obj, donation_qty: parseInt(value) };
            }
          }
          return obj;
        }
      );
    },

    async onShowConfirm() {
      this.$bvModal
        .msgBoxConfirm("Bạn có chắc chắn muốn huỷ chương trình này không?", {
          title: "Xác nhận huỷ chương trình",
          okVariant: "danger",
          okTitle: "Đồng ý",
          cancelTitle: "Thôi",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (action) => {
          if (action) {
            await this.onCancelPromotion();
          }
        });
    },

    async onCancelPromotion() {
      const body = {
        id: this.detailData.id,
        status: "CANCELED",
      };
      const response = await promotionService.updatePromotion(body);
      if (response.data.data) {
        this.$notify({
          group: "app",
          type: "success",
          text: "Huỷ chương trình thành công",
        });
        this.$router.push("/promotion/brand");
      } else {
        this.$notify({
          group: "app",
          type: "error",
          title: "Đã có lỗi xảy ra, vui lòng kiểm tra lại",
          text: response.data.error.message,
        });
      }
    },

    async onUpdatePromotion() {
      if (
        this.formData.name.trim() !== "" &&
        this.formData.date &&
        this.formData.brand &&
        this.formData.channel &&
        this.formData.promotionTypeExtra &&
        (this.listRule.length > 0 ||
          (this.formData.promotionTypeExtra.id === "CUSTOMIZE" &&
            this.formData.promotionValidId))
      ) {
        const detailRule = this.listRule.map((e) => {
          let obj = {
            from_level:
              e.fromLevel && e.fromLevel !== ""
                ? parseFloat(e.fromLevel)
                : null,
            to_level:
              e.toLevel && e.toLevel !== "" ? parseFloat(e.toLevel) : null,
            level_type: e.levelType,
            discount_rate:
              e.discountRate && e.discountRate !== ""
                ? parseFloat(e.discountRate)
                : 0,
            discount_type: e.discountType,
            list_item_uid: e.item.map((f) => f.id),
            item_donation: null,
          };
          switch (e.discountType) {
            case "PERCENTAGE":
              if (e.levelType === "AMOUNT_BILL") {
                obj.discount_rate_max = e.discountRateMax
                  ? e.discountRateMax
                  : null;
              }
              return obj;
            case "MONEY_REDUCTION":
            case "PRICE_REDUCTION":
              return obj;
            case "ITEM_DONATION":
            case "PERCENTAGE_DONATION":
            case "MONEY_REDUCTION_DONATION":
            case "PERCENTAGE_OR_DONATION":
            case "MONEY_REDUCTION_OR_DONATION":
              if (e.giftType !== "BOTH") {
                return {
                  ...obj,
                  item_donation: {
                    type: e.giftType,
                    details: e.listGiftSelected,
                  },
                };
              } else {
                return {
                  ...obj,
                  item_donation: {
                    type: e.giftType,
                    details: [],
                    list_rule: e.listRuleGift.map((e) => {
                      return { name: e.name, details: e.listGiftSelected };
                    }),
                  },
                };
              }
          }
        });
        const body = {
          id: this.detailData.id,
          promotion_type_extra: this.formData.promotionTypeExtra.id,
          promotion_apply_type: this.formData.promotionApplyType && this.formData.promotionApplyType.id || null,
          promotion_name: this.formData.name,
          promotion_type: "TRADEMARK",
          trademark_uid: this.formData.brand.id,
          description: this.editorData,
          from_date: this.formData.date[0].setHours(0, 0, 0, 0),
          to_date: this.formData.date[1].setHours(23, 59, 59, 999),
          image_url: this.formData.imageUrl,
          image_url_thumb: this.formData.imageUrlThumb,
          details: detailRule,
          list_sale_channel_id: this.formData.channel
            .map((e) => e.channel_id)
            .includes("ALL")
            ? ["ALL"]
            : this.formData.channel.map((e) => e.channel_id),
          promotion_valid_id:
            this.formData.promotionTypeExtra.id === "CUSTOMIZE"
              ? this.formData.promotionValidId
              : null,
        };
        this.isBtnLoading = true;
        const response = await promotionService.updatePromotion(body);
        this.isBtnLoading = false;
        if (response.data.data) {
          this.$notify({
            group: "app",
            type: "success",
            title: "Cập nhật chương trình thành công",
            text: "Vui lòng chờ chủ NPP duyệt để chương trình chính thức hoạt động",
          });
          await this.getDetailData();
        } else {
          this.$notify({
            group: "app",
            type: "error",
            title: "Đã có lỗi xảy ra, vui lòng kiểm tra lại",
            text: response.data.error.message,
          });
        }
      } else {
        this.$notify({
          group: "app",
          type: "error",
          title: "Nhập đẩy đủ thông tin chương trình",
          text: "Nhập tên chương trình, loại chương trình, kênh áp dụng, nhóm khách hàng, thời gian áp dụng, nhãn hàng và rule giảm giá",
        });
      }
    },


    async onUpdatePromotionConfirmer() {
      if (
        this.formData.name.trim() !== ""
      ) {
        const body = {
          id: this.detailData.id,
          promotion_name: this.formData.name,
          description: this.editorData,
          image_url: this.formData.imageUrl,
          image_url_thumb: this.formData.imageUrlThumb,
        };
        this.isBtnLoading = true;
        const response = await promotionService.updatePromotion(body);
        this.isBtnLoading = false;
        if (response.data.data) {
          this.$notify({
            group: "app",
            type: "success",
            title: "Cập nhật chương trình thành công",
          });
          await this.getDetailData();
        } else {
          this.$notify({
            group: "app",
            type: "error",
            title: "Đã có lỗi xảy ra, vui lòng kiểm tra lại",
            text: response.data.error.message,
          });
        }
      } else {
        this.$notify({
          group: "app",
          type: "error",
          title: "Nhập đẩy đủ thông tin chương trình",
          text: "Nhập tên chương trình",
        });
      }
    },

    onChangeItemGiftBoth(i) {
      this.formRule.listRuleGift[i].listGiftSelected =
        this.formRule.listRuleGift[i].itemGift.map((e) => {
          return {
            id: e.id,
            sku: e.sku,
            item_name: e.name,
            unit_id: e.unit.unit_id,
            unit_name: e.unit.unit_name,
            donation_qty: e.donation_qty,
            trademark_uid: e.trademark_uid,
          };
        });
    },

    onChangeQuantityBoth(value, id, index) {
      this.formRule.listRuleGift[index].listGiftSelected =
        this.formRule.listRuleGift[index].listGiftSelected.map((obj) => {
          if (obj.id === id) {
            if (parseInt(value) > 0) {
              return { ...obj, donation_qty: parseInt(value) };
            }
          }
          return obj;
        });
    },

    onAddRuleBoth() {
      this.formRule.listRuleGift.push({
        name: "Nhóm " + (this.formRule.listRuleGift.length + 1),
        itemGift: [],
        listGiftSelected: [],
      });
    },

    onChangeTypeExtra(e) {
      this.formData.promotionTypeExtra = e;
      this.listRule = [];
      if(this.formData.promotionTypeExtra && this.formData.promotionTypeExtra.id === "PER_ORDER") {
        this.formData.promotionApplyType = this.listPromotionApplyType[0];
      }else{
        this.formData.promotionApplyType = undefined
      }
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div
        class="col-lg-6 col-md-12 col-sm-12 mb-2"
        style="padding-left: 5px; padding-right: 5px"
      >
        <div class="bg-white box-shadow" style="border: 1px solid #eff2f7">
          <TableLoading v-if="isBusy" />
          <template v-else>
            <div class="bg-white p-3">
              <div class="alert alert-info">
                Chương trình khuyến mại sẽ được hiển thị trên ứng dụng POP và
                các kênh bán hàng khác của hệ thống IDS
              </div>
              <div class="form-group">
                <label
                  >Loại chương trình <span class="text-danger">*</span></label
                >
                <div class="input-group">
                  <multiselect
                    id="channel"
                    v-model="formData.promotionTypeExtra"
                    :options="listTypeExtra"
                    track-by="id"
                    label="name"
                    placeholder="Chọn loại chương trình"
                    noOptions="Danh sách trống"
                    :show-labels="false"
                    class="custom-multi-select"
                    :multiple="false"
                    @select="onChangeTypeExtra"
                    :disabled="!isEdit"
                  ></multiselect>
                </div>
              </div>
              <div class="form-group" v-if="showApplyType">
                <label
                >Cách thức áp dụng <span class="text-danger">*</span></label
                >
                <div class="input-group">
                  <multiselect
                      id="applyType"
                      v-model="formData.promotionApplyType"
                      :options="listPromotionApplyType"
                      track-by="id"
                      label="name"
                      placeholder="Chọn cách thức áp dụng"
                      noOptions="Danh sách trống"
                      :show-labels="false"
                      class="custom-multi-select"
                      :multiple="false"
                      :allowEmpty="false"
                      :disabled="!isEdit"
                  ></multiselect>
                </div>
              </div>
              <div class="form-group">
                <label>Kênh áp dụng <span class="text-danger">*</span></label>
                <div class="input-group">
                  <multiselect
                    id="channel"
                    v-model="formData.channel"
                    :options="listChannel"
                    track-by="channel_id"
                    label="channel_name"
                    placeholder="Chọn kênh áp dụng"
                    noOptions="Danh sách trống"
                    :show-labels="false"
                    class="custom-multi-select"
                    :multiple="true"
                    :disabled="!isEdit"
                  ></multiselect>
                </div>
              </div>
              <div class="form-group">
                <label
                  >Tên chương trình <span class="text-danger">*</span></label
                >
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Nhập tên chương trình"
                    aria-label="Nhập tên chương trình"
                    v-model="formData.name"
                  />
                </div>
              </div>
              <div class="form-group">
                <label>Chi tiết chương trình</label>
                <ckeditor
                  v-model="editorData"
                  :editor="editor"
                ></ckeditor>
              </div>
              <div class="form-group mb-0">
                <div class="position-relative">
                  <picture-input
                    ref="pictureInput"
                    width="800"
                    height="450"
                    accept="image/jpeg,image/png"
                    size="10"
                    radius="1"
                    button-class="btn"
                    :prefill="formData.imageUrl"
                    :custom-strings="{
                      drag: 'Chọn ảnh chương trình tỉ lệ 16:9',
                      remove: 'x',
                    }"
                    @change="onChangeImage()"
                    @remove="removeImage()"
                    :hideChangeButton="true"
                    :zIndex="1"
                    :removable="true"
                    removeButtonClass="btn btn-secondary btn-remove"
                  >
                  </picture-input>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div
        class="col-lg-6 col-md-12 col-sm-12 mb-2"
        style="padding-left: 5px; padding-right: 5px"
      >
        <div class="bg-white box-shadow" style="border: 1px solid #eff2f7">
          <TableLoading v-if="isBusy" />
          <template v-else>
            <div class="bg-white p-3">
              <div class="form-group">
                <label
                  >Thời gian áp dụng <span class="text-danger">*</span></label
                >
                <date-picker
                  v-model="formData.date"
                  :first-day-of-week="1"
                  lang="en"
                  range
                  format="DD/MM/YYYY"
                  placeholder="Chọn khoảng thời gian"
                  :disabled="!isEdit"
                  :shortcuts="shortcutsFeature"
                ></date-picker>
              </div>
              <div class="form-group mb-0">
                <label>Nhãn hàng <span class="text-danger">*</span></label>
                <multiselect
                  v-model="formData.brand"
                  :options="listBrand"
                  track-by="id"
                  label="trademark_name"
                  placeholder="Chọn nhãn hàng"
                  noOptions="Danh sách trống"
                  :allowEmpty="false"
                  :show-labels="false"
                  :disabled="!isEdit"
                  @select="onChangeBrand"
                ></multiselect>
              </div>
              <div
                class="form-group mt-3"
                v-if="formData.promotionTypeExtra.id === 'CUSTOMIZE'"
              >
                <label
                  >Nhập mã điều kiện <span class="text-danger">*</span></label
                >
                <div class="alert alert-info">
                  Lưu ý: Mã điều kiện sẽ được cung cấp dựa theo từng chương
                  trình khuyến mãi
                </div>
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Nhập mã điều kiện"
                    aria-label="Nhập mã điều kiện"
                    v-model="formData.promotionValidId"
                    :disabled="!(detailData.status === 'PENDING')"
                  />
                </div>
              </div>
            </div>
          </template>
        </div>
        <div
          v-if="formData.promotionTypeExtra.id !== 'CUSTOMIZE'"
          class="bg-white box-shadow mt-2"
          style="border: 1px solid #eff2f7"
        >
          <TableLoading v-if="isBusy" />
          <template v-else>
            <div class="bg-white p-3">
              <div class="table-responsive" v-if="listRule.length > 0">
                <table class="table table-bordered scroll-table">
                  <tr>
                    <th>Hàng hoá</th>
                    <th class="min-w-100">Khuyến mãi</th>
                    <th
                      class="min-w-100"
                      v-if="detailData.status === 'CONFIRMED'"
                    >
                      Trạng thái
                    </th>
                    <th v-if="detailData.status === 'PENDING'"></th>
                    <th
                      v-if="detailData.status === 'CONFIRMED' && !isApproveAl"
                    ></th>
                  </tr>
                  <tr v-for="(data, index) in listRule" :key="index">
                    <td>
                      <template v-if="data.id !== 'ALL'">
                        <p
                          v-for="(item, i) in data.item"
                          :key="i"
                          :class="i + 1 === data.item.length ? 'mb-0' : 'mb-2'"
                        >
                          {{ item.sku }} - {{ item.name }}
                        </p>
                      </template>
                      <template v-else>Tất cả hàng hoá</template>
                    </td>
                    <td>
                      <p class="mb-1">
                        <span v-if="data.levelType === 'AMOUNT'"
                          >Mua tổng tiền mặt hàng
                        </span>
                        <span v-if="data.levelType === 'AMOUNT_BILL'"
                          >Mua tổng tiền đơn hàng
                        </span>
                        <span v-if="data.levelType === 'QUANTITY'"
                          >Mua số lượng
                        </span>
                        từ {{ formatPrice(data.fromLevel) }}
                        <span v-if="data.toLevel"
                          >đến {{ formatPrice(data.toLevel) }}</span
                        >
                      </p>
                      <p
                        class="mb-1"
                        v-if="
                          data.discountType === 'PERCENTAGE' ||
                          data.discountType === 'PERCENTAGE_DONATION' ||
                          data.discountType === 'PERCENTAGE_OR_DONATION'
                        "
                      >
                        {{formData.promotionTypeExtra.id === 'PER_ORDER' ? 'Chiết khấu' : 'Giảm giá'}} {{ data.discountRate }} %
                        <span
                          v-if="
                            data.levelType === 'AMOUNT_BILL' &&
                            data.discountRateMax
                          "
                        >
                          <br />
                          - {{formData.promotionTypeExtra.id === 'PER_ORDER' ? 'Chiết khấu tối đa' : 'Giảm giá tối đa'}}
                          {{ formatPrice(data.discountRateMax,true) }}
                        </span>
                      </p>
                      <p
                        class="mb-1"
                        v-if="
                          data.discountType === 'MONEY_REDUCTION' ||
                          data.discountType === 'MONEY_REDUCTION_DONATION' ||
                          data.discountType === 'MONEY_REDUCTION_OR_DONATION'
                        "
                      >
                        {{formData.promotionTypeExtra.id === 'PER_ORDER' ? 'Chiết khấu' : 'Giảm giá'}} {{ formatPrice(data.discountRate,true) }}
                      </p>
                      <p
                        class="mb-1"
                        v-if="data.discountType === 'PRICE_REDUCTION'"
                      >
                        Giảm giá bán {{ formatPrice(data.discountRate, true) }}
                      </p>
                      <p
                        class="mb-1"
                        v-if="
                          data.discountType === 'PERCENTAGE_DONATION' ||
                          data.discountType === 'MONEY_REDUCTION_DONATION'
                        "
                      >
                        và
                      </p>
                      <p
                        class="mb-1"
                        v-if="
                          data.discountType === 'PERCENTAGE_OR_DONATION' ||
                          data.discountType === 'MONEY_REDUCTION_OR_DONATION'
                        "
                      >
                        hoặc
                      </p>
                      <p
                        class="mb-1"
                        v-if="
                          data.discountType === 'ITEM_DONATION' ||
                          data.discountType === 'PERCENTAGE_DONATION' ||
                          data.discountType === 'PERCENTAGE_OR_DONATION' ||
                          data.discountType === 'MONEY_REDUCTION_DONATION' ||
                          data.discountType === 'MONEY_REDUCTION_OR_DONATION'
                        "
                      >
                        <span class="d-block mb-1" v-if="data.giftType === 'OR'"
                          >Tặng 1 trong các hàng hoá dưới đây</span
                        >
                        <span class="d-block" v-if="data.giftType === 'AND'"
                          >Tặng tất cả các hàng hoá dưới đây</span
                        >
                        <span class="d-block" v-if="data.giftType === 'BOTH'"
                          >Tặng 1 trong các nhóm hàng hoá dưới đây</span
                        >
                        <span v-if="data.giftType !== 'BOTH'">
                          <span
                            class="d-block font-italic"
                            v-for="gift in data.listGiftSelected"
                            :key="gift.id"
                          >
                            - {{ gift.item_name }} - SL: {{ gift.donation_qty }}
                          </span>
                        </span>
                        <span v-else>
                          <span
                            class="d-block font-italic"
                            v-for="listGift in data.listRuleGift"
                            :key="listGift.name"
                          >
                            + {{ listGift.name }} :
                            <span
                              class="d-block font-italic pl-2"
                              v-for="gift in listGift.listGiftSelected"
                              :key="gift.id"
                            >
                              - {{ gift.item_name }} - SL:
                              {{ gift.donation_qty }}
                            </span>
                          </span>
                        </span>
                      </p>
                    </td>
                    <td v-if="detailData.status === 'CONFIRMED'">
                      <span
                        class="badge badge-pill badge-success p-2"
                        v-if="data.status === 'CONFIRMED'"
                      >
                        ĐANG CHẠY
                      </span>
                      <span
                        class="badge badge-pill badge-secondary p-2"
                        v-if="data.status === 'CANCELED'"
                      >
                        ĐÃ HUỶ
                      </span>
                      <span
                        class="badge badge-pill badge-info p-2"
                        v-if="data.status === 'NEW_ADD'"
                      >
                        VỪA THÊM
                      </span>
                    </td>
                    <td v-if="detailData.status === 'PENDING' && isEdit">
                      <i
                        @click="removeRule(data)"
                        class="
                          bx bx-x-circle
                          font-size-16
                          text-danger
                          ipos-pointer
                        "
                      ></i>
                    </td>
                    <td
                      v-if="detailData.status === 'CONFIRMED' && !isApproveAll"
                    >
                      <i
                        v-if="data.status === 'CONFIRMED'"
                        @click="cancelRule(data)"
                        class="
                          bx bx-x-circle
                          font-size-16
                          text-danger
                          ipos-pointer
                        "
                      ></i>
                      <i
                        v-if="data.status === 'NEW_ADD'"
                        @click="removeRule(data)"
                        class="
                          bx bx-x-circle
                          font-size-16
                          text-danger
                          ipos-pointer
                        "
                      ></i>
                    </td>
                  </tr>
                </table>
              </div>
              <div
                class="form-group mb-0 text-center"
                v-if="
                  (!isApproveAll && detailData.status === 'CONFIRMED') ||
                  detailData.status === 'PENDING'
                "
              >
                <button
                  type="button"
                  class="btn btn-label btn-outline-primary"
                  @click="handleAddItem('add')"
                >
                  <i class="bx bx-plus label-icon"></i> Thêm rule giảm giá
                </button>
                <button
                  v-if="
                    detailData.status === 'PENDING' &&
                    formData.promotionTypeExtra.id === 'PER_ITEM'
                  "
                  type="button"
                  class="btn btn-label btn-outline-secondary ml-2"
                  @click="handleAddItem('import')"
                >
                  <i class="bx bx-import label-icon"></i> Import rule giảm giá
                </button>
              </div>
            </div>
          </template>
        </div>
        <div class="text-right mt-3">
          <button
            v-if="detailData.status === 'PENDING'"
            type="button"
            class="btn btn-danger mr-2"
            @click="onShowConfirm"
          >
            Huỷ chương trình
          </button>
          <button
            v-if="detailData.status === 'PENDING'"
            type="button"
            class="btn btn-primary"
            @click="onUpdatePromotion"
            :disabled="isBtnLoading"
          >
            <template v-if="isBtnLoading">
              <i
                class="bx bx-loader bx-spin font-size-16 align-middle mr-2"
              ></i>
              Đang xử lý...
            </template>
            <template v-else>Cập nhật chương trình</template>
          </button>
          <button
            v-if="detailData.status === 'CONFIRMED'"
            type="button"
            class="btn btn-primary"
            @click="onUpdatePromotionConfirmer"
            :disabled="isBtnLoading"
          >
            <template v-if="isBtnLoading">
              <i
                class="bx bx-loader bx-spin font-size-16 align-middle mr-2"
              ></i>
              Đang xử lý...
            </template>
            <template v-else>Cập nhật chương trình</template>
          </button>
        </div>
      </div>
    </div>
    <!-- Modal Add/Edit -->
    <b-modal
      id="md-crud"
      title="Thêm sản phẩm khuyến mại"
      @hidden="resetHideFormRule"
      size="lg"
      centered
      hide-footer
    >
      <form>
        <!-- Hàng hoá -->
        <div class="row">
          <div class="col-lg-12">
            <div class="form-group">
              <label for="item">Hàng hoá áp dụng</label>
              <multiselect
                id="item"
                v-model="formRule.item"
                :options="listItem"
                track-by="id"
                label="name"
                placeholder="Chọn hàng hoá"
                noOptions="Danh sách trống"
                :multiple="true"
                :show-labels="false"
              >
                <template slot="option" slot-scope="props">
                  <div class="d-flex justify-content-between">
                    <span class="option__title">{{ props.option.name }}</span>
                    <span
                      v-if="props.option.isRule"
                      class="badge badge-pill badge-danger"
                      >Đã có rule</span
                    >
                  </div>
                </template>
              </multiselect>
            </div>
          </div>
        </div>
        <!-- Điều kiện -->
        <div class="row">
          <div class="col-lg-12">
            <div class="form-group mb-2">
              <label>Điều kiện</label>
              <multiselect
                id="levelType"
                v-model="formRule.levelType"
                :options="listType"
                track-by="id"
                label="name"
                placeholder="Chọn điều kiện"
                noOptions="Danh sách trống"
                :allowEmpty="false"
                :show-labels="false"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-12">
            <div class="form-group">
              <div
                class="input-group"
                v-if="
                  formRule.levelType.id === 'AMOUNT' ||
                  formRule.levelType.id === 'AMOUNT_BILL'
                "
              >
                <span class="input-group-text border-radius-right0 mrn1"
                  >Từ</span
                >
                <input
                  type="number"
                  class="form-control"
                  v-model="formRule.fromLevel"
                  placeholder="Nhập số tiền"
                  aria-label="Nhập số tiền"
                />
                <span
                  class="
                    input-group-text
                    border-radius-right0 border-radius-left0
                    mrn1
                    mln1
                  "
                  >đến</span
                >
                <input
                  type="number"
                  class="form-control"
                  v-model="formRule.toLevel"
                  placeholder="Nhập số tiền"
                  aria-label="Nhập số tiền"
                />
              </div>
              <div
                class="input-group"
                v-if="formRule.levelType.id === 'QUANTITY'"
              >
                <span class="input-group-text border-radius-right0 mrn1"
                  >Từ</span
                >
                <input
                  type="number"
                  class="form-control"
                  v-model="formRule.fromLevel"
                  placeholder="Nhập số lượng"
                  aria-label="Nhập số lượng"
                />
                <span
                  class="
                    input-group-text
                    border-radius-right0 border-radius-left0
                    mln1
                    mrn1
                  "
                  >đến</span
                >
                <input
                  type="number"
                  class="form-control"
                  v-model="formRule.toLevel"
                  placeholder="Nhập số lượng"
                  aria-label="Nhập số lượng"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- Loại giảm giá -->
        <div class="row">
          <div class="col-lg-12">
            <div class="form-group mb-2">
              <label>Loại giảm giá</label>
              <multiselect
                id="discountType"
                v-model="formRule.discountType"
                :options="
                  formRule.levelType.id === 'AMOUNT_BILL'
                    ? listDiscountTypeForAmountBill
                    : listDiscountType
                "
                track-by="id"
                label="name"
                placeholder="Chọn loại giảm giá"
                noOptions="Danh sách trống"
                :allowEmpty="false"
                :show-labels="false"
              ></multiselect>
            </div>
          </div>
          <div
            class="col-lg-12"
            v-if="
              formRule.discountType.id === 'PERCENTAGE' ||
              formRule.discountType.id === 'PERCENTAGE_DONATION' ||
              formRule.discountType.id === 'PERCENTAGE_OR_DONATION'
            "
          >
            <div class="form-group">
              <div class="input-group">
                <input
                  type="number"
                  class="form-control"
                  placeholder="Nhập phần trăm giảm giá"
                  aria-label="Nhập phần trăm giảm giá"
                  v-model="formRule.discountRate"
                  aria-describedby="discount-value"
                />
                <div class="input-group-append">
                  <span class="input-group-text">%</span>
                </div>
              </div>
            </div>
            <!-- Số tiền giảm giá tối đa -->
            <div
              v-if="formRule.levelType.id === 'AMOUNT_BILL'"
              class="form-group"
            >
              <div class="input-group">
                <input
                  type="number"
                  class="form-control"
                  placeholder="Nhập giảm giá tối đa"
                  aria-label="Nhập giảm giá tối đa"
                  v-model="formRule.discountRateMax"
                  aria-describedby="discount-value"
                />
                <div class="input-group-append">
                  <span class="input-group-text">{{currencyType}}</span>
                </div>
              </div>
            </div>
          </div>
          <div
            class="col-lg-12"
            v-if="
              formRule.discountType.id === 'MONEY_REDUCTION' ||
              formRule.discountType.id === 'PRICE_REDUCTION' ||
              formRule.discountType.id === 'MONEY_REDUCTION_DONATION' ||
              formRule.discountType.id === 'MONEY_REDUCTION_OR_DONATION'
            "
          >
            <div class="form-group">
              <div class="input-group">
                <input
                  type="number"
                  class="form-control"
                  placeholder="Nhập số tiền"
                  aria-label="Nhập số tiền"
                  v-model="formRule.discountRate"
                  aria-describedby="discount-value"
                />
                <div class="input-group-append">
                  <span class="input-group-text">{{currencyType}}</span>
                </div>
              </div>
            </div>
          </div>
          <!-- Check kiểu tặng hàng hóa 'AND' và 'OR' -->
          <div class="w-100" v-if="formRule.giftType.id !== 'BOTH'">
            <div
              class="col-lg-12"
              v-if="
                formRule.discountType.id === 'ITEM_DONATION' ||
                formRule.discountType.id === 'PERCENTAGE_DONATION' ||
                formRule.discountType.id === 'MONEY_REDUCTION_DONATION' ||
                formRule.discountType.id === 'PERCENTAGE_OR_DONATION' ||
                formRule.discountType.id === 'MONEY_REDUCTION_OR_DONATION'
              "
            >
              <div class="form-group mb-2">
                <multiselect
                  v-model="formRule.itemGift"
                  :options="listItemOrigin"
                  track-by="id"
                  label="name"
                  placeholder="Chọn hàng hoá tặng"
                  noOptions="Danh sách trống"
                  :show-labels="false"
                  :multiple="true"
                  @input="onChangeItemGift"
                ></multiselect>
              </div>
            </div>
            <div
              class="col-lg-12"
              v-if="
                formRule.discountType.id === 'ITEM_DONATION' ||
                formRule.discountType.id === 'PERCENTAGE_DONATION' ||
                formRule.discountType.id === 'MONEY_REDUCTION_DONATION' ||
                formRule.discountType.id === 'PERCENTAGE_OR_DONATION' ||
                formRule.discountType.id === 'MONEY_REDUCTION_OR_DONATION'
              "
            >
              <div
                class="form-group mtn1 mb-0"
                v-for="(item, i) in formRule.listGiftSelected"
                :key="i"
              >
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text min-w-200">{{
                      item.item_name
                    }}</span>
                  </div>
                  <b-input
                    type="number"
                    class="form-control"
                    @input="onChangeQuantity($event, item.id)"
                    :value="item.donation_qty"
                    placeholder="Nhập số lượng tặng"
                    aria-label="Nhập số lượng tặng"
                    aria-describedby="discount-value"
                  />
                </div>
              </div>
            </div>
          </div>

          <!-- Check kiểu tặng hàng hóa 'BOTH' -->
          <div class="w-100" v-else>
            <div
              class="w-100"
              v-if="
                formRule.discountType.id === 'ITEM_DONATION' ||
                formRule.discountType.id === 'PERCENTAGE_DONATION' ||
                formRule.discountType.id === 'MONEY_REDUCTION_DONATION' ||
                formRule.discountType.id === 'PERCENTAGE_OR_DONATION' ||
                formRule.discountType.id === 'MONEY_REDUCTION_OR_DONATION'
              "
            >
              <div
                v-for="(ruleGift, idx) in formRule.listRuleGift"
                :key="idx"
                class="border pt-2 pb-2 mb-1"
              >
                <div class="col-lg-12">
                  <div class="form-group mb-2">
                    <multiselect
                      v-model="ruleGift.itemGift"
                      :options="listItemOrigin"
                      track-by="id"
                      label="name"
                      placeholder="Chọn hàng hoá tặng"
                      noOptions="Danh sách trống"
                      :show-labels="false"
                      :multiple="true"
                      @input="onChangeItemGiftBoth(idx)"
                    ></multiselect>
                  </div>
                </div>
                <div class="col-lg-12">
                  <div
                    class="form-group mtn1 mb-0"
                    v-for="(item, i) in ruleGift.listGiftSelected"
                    :key="i"
                  >
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text min-w-200">{{
                          item.item_name
                        }}</span>
                      </div>
                      <b-input
                        type="number"
                        class="form-control"
                        @input="onChangeQuantityBoth($event, item.id, idx)"
                        :value="item.donation_qty"
                        placeholder="Nhập số lượng tặng"
                        aria-label="Nhập số lượng tặng"
                        aria-describedby="discount-value"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- thêm nhóm tặng nhiều hàng hóa -->
            <div class="col-lg-12 pt-1">
              <button
                type="button"
                class="btn btn-sm btn-outline-primary"
                @click="onAddRuleBoth"
              >
                Thêm nhóm
              </button>
            </div>
          </div>
          <div
            class="col-lg-12"
            v-if="
              formRule.discountType.id === 'ITEM_DONATION' ||
              formRule.discountType.id === 'PERCENTAGE_DONATION' ||
              formRule.discountType.id === 'MONEY_REDUCTION_DONATION' ||
              formRule.discountType.id === 'PERCENTAGE_OR_DONATION' ||
              formRule.discountType.id === 'MONEY_REDUCTION_OR_DONATION'
            "
          >
            <div class="form-group mt-2 mb-2">
              <multiselect
                v-model="formRule.giftType"
                :options="listGiftType"
                track-by="id"
                label="name"
                placeholder="Chọn kiểu tặng"
                noOptions="Danh sách trống"
                :show-labels="false"
                :allowEmpty="false"
              ></multiselect>
            </div>
          </div>
        </div>
      </form>
      <footer class="modal-footer px-0 pb-0">
        <button type="button" class="btn btn-primary" @click="onAddRule">
          Thêm
        </button>
      </footer>
    </b-modal>
    <!-- Modal Import -->
    <b-modal
      id="md-import"
      title="Import rule giảm giá"
      @hidden="resetHideFormRule"
      size="lg"
      centered
      hide-footer
    >
      <form>
        <div class="row mb-3">
          <div class="col-lg-3">
            <a
              @click="onChangeTab(1)"
              class="btn rounded-pill mb-2"
              :class="{ 'btn-secondary': step === 1, 'btn-light': step === 2 }"
            >
              Bước 1: Chọn file
            </a>
            <a
              @click="onChangeTab(2)"
              class="btn rounded-pill"
              :class="{ 'btn-secondary': step === 2, 'btn-light': step === 1 }"
            >
              Bước 2: Kiểm tra dữ liệu
            </a>
          </div>
          <div class="col-lg-9">
            <div class="row" v-if="step === 1">
              <div class="col-lg-12">
                <div class="alert alert-warning" v-if="listRule.length > 0">
                  Đang có rule khuyến mãi khác, nếu import hệ thống sẽ XOÁ rule
                  cũ ghi toàn bộ rule mới.
                </div>
              </div>
              <div class="col-lg-12">
                <p class="mb-2">
                  Chọn file dữ liệu chuẩn bị import vào phần mềm
                </p>
                <b-form-file
                  v-model="fileImport"
                  :state="Boolean(fileImport)"
                  placeholder="Chọn file hoặc kéo file vào đây..."
                  drop-placeholder="Kéo file vào đây..."
                ></b-form-file>
                <p class="mt-2">
                  Tải tệp excel mẫu
                  <a href="/dl/IMPORT_DISCOUNT_TRADEMARK.xlsx">tại đây</a>
                </p>
              </div>
            </div>
            <div class="row" v-if="step === 2">
              <div class="col-lg-12" v-if="listError.length > 0">
                <div class="alert alert-danger">
                  Vui lòng kiểm tra và chỉnh sửa lại file import, có lỗi ở các
                  dòng dưới đây
                </div>
              </div>
              <div class="col-lg-12">
                <a
                  @click="onChangeTabCheck(1)"
                  class="btn btn-sm rounded-pill mr-2 mb-3"
                  :class="{
                    'btn-danger': tabCheck === 1,
                    'btn-outline-secondary': tabCheck === 2,
                  }"
                >
                  Lỗi ({{ listError.length }})
                </a>
                <a
                  @click="onChangeTabCheck(2)"
                  class="btn btn-sm rounded-pill mb-3"
                  :class="{
                    'btn-success': tabCheck === 2,
                    'btn-outline-secondary': tabCheck === 1,
                  }"
                >
                  Hợp lệ ({{ listSuccess.length }})
                </a>
              </div>
              <div
                class="col-lg-12"
                v-if="tabCheck === 1 && listError.length > 0"
              >
                <table class="table table-bordered">
                  <tr>
                    <th>SKU</th>
                    <th>Khuyến mãi</th>
                    <th>Thời gian</th>
                    <th>Lỗi</th>
                  </tr>
                  <tr v-for="(item, i) in listError" :key="i">
                    <td>{{ item.list_sku_str }}</td>
                    <td>
                      <p class="mb-1">
                        <span v-if="item.level_type === 'AMOUNT'"
                          >Mua tổng tiền
                        </span>
                        <span v-if="item.level_type === 'QUANTITY'"
                          >Mua số lượng
                        </span>
                        từ {{ formatPrice(item.from_level) }}
                        <span v-if="item.to_level"
                          >đến {{ formatPrice(item.to_level) }}</span
                        >
                      </p>
                      <p
                        class="mb-1"
                        v-if="
                          item.discount_type === 'PERCENTAGE' ||
                          item.discount_type === 'PERCENTAGE_DONATION' ||
                          item.discount_type === 'PERCENTAGE_OR_DONATION'
                        "
                      >
                        Giảm giá {{ item.discount_rate }} %
                      </p>
                      <p
                        class="mb-1"
                        v-if="
                          item.discount_type === 'MONEY_REDUCTION' ||
                          item.discount_type === 'MONEY_REDUCTION_DONATION' ||
                          item.discount_type === 'MONEY_REDUCTION_OR_DONATION'
                        "
                      >
                        Giảm giá {{ formatPrice(item.discount_rate, true) }}
                      </p>
                      <p
                        class="mb-1"
                        v-if="item.discount_type === 'PRICE_REDUCTION'"
                      >
                        Giảm giá bán {{ formatPrice(item.discount_rate, true) }}
                      </p>
                      <p
                        class="mb-1"
                        v-if="
                          item.discount_type === 'PERCENTAGE_DONATION' ||
                          item.discount_type === 'MONEY_REDUCTION_DONATION'
                        "
                      >
                        và
                      </p>
                      <p
                        class="mb-1"
                        v-if="
                          item.discount_type === 'PERCENTAGE_OR_DONATION' ||
                          item.discount_type === 'MONEY_REDUCTION_OR_DONATION'
                        "
                      >
                        hoặc
                      </p>
                      <p
                        class="mb-1"
                        v-if="
                          item.discount_type === 'ITEM_DONATION' ||
                          item.discount_type === 'PERCENTAGE_DONATION' ||
                          item.discount_type === 'PERCENTAGE_OR_DONATION' ||
                          item.discount_type === 'MONEY_REDUCTION_DONATION' ||
                          item.discount_type === 'MONEY_REDUCTION_OR_DONATION'
                        "
                      >
                        <span
                          class="d-block mb-1"
                          v-if="item.item_donation_type === 'OR'"
                          >Tặng 1 trong các hàng hoá dưới đây</span
                        >
                        <span
                          class="d-block"
                          v-if="item.item_donation_type === 'AND'"
                          >Tặng tất cả các hàng hoá dưới đây</span
                        >
                        <span
                          class="d-block font-italic"
                          v-for="gift in item.item_donation_id.split(',')"
                          :key="gift"
                        >
                          - {{ gift }}
                        </span>
                      </p>
                    </td>
                    <td>
                      <p class="mb-1">{{ formatDate(formData.date[0]) }}</p>
                      <span class="d-block">{{
                        formatDate(formData.date[1])
                      }}</span>
                    </td>
                    <td>{{ item.error_message }}</td>
                  </tr>
                </table>
              </div>
              <div
                class="col-lg-12"
                v-if="tabCheck === 2 && listSuccess.length > 0"
              >
                <table class="table table-bordered">
                  <tr>
                    <th>SKU</th>
                    <th>Khuyến mãi</th>
                    <th>Thời gian</th>
                  </tr>
                  <tr v-for="(item, i) in listSuccess" :key="i">
                    <td>{{ item.list_sku_str }}</td>
                    <td>
                      <p class="mb-1">
                        <span v-if="item.level_type === 'AMOUNT'"
                          >Mua tổng tiền
                        </span>
                        <span v-if="item.level_type === 'QUANTITY'"
                          >Mua số lượng
                        </span>
                        từ {{ formatPrice(item.from_level) }}
                        <span v-if="item.to_level"
                          >đến {{ formatPrice(item.to_level) }}</span
                        >
                      </p>
                      <p
                        class="mb-1"
                        v-if="
                          item.discount_type === 'PERCENTAGE' ||
                          item.discount_type === 'PERCENTAGE_DONATION' ||
                          item.discount_type === 'PERCENTAGE_OR_DONATION'
                        "
                      >
                        Giảm giá {{ item.discount_rate }} %
                      </p>
                      <p
                        class="mb-1"
                        v-if="
                          item.discount_type === 'MONEY_REDUCTION' ||
                          item.discount_type === 'MONEY_REDUCTION_DONATION' ||
                          item.discount_type === 'MONEY_REDUCTION_OR_DONATION'
                        "
                      >
                        Giảm giá {{ formatPrice(item.discount_rate, true) }}
                      </p>
                      <p
                        class="mb-1"
                        v-if="item.discount_type === 'PRICE_REDUCTION'"
                      >
                        Giảm giá bán {{ formatPrice(item.discount_rate, true) }}
                      </p>
                      <p
                        class="mb-1"
                        v-if="
                          item.discount_type === 'PERCENTAGE_DONATION' ||
                          item.discount_type === 'MONEY_REDUCTION_DONATION'
                        "
                      >
                        và
                      </p>
                      <p
                        class="mb-1"
                        v-if="
                          item.discount_type === 'PERCENTAGE_OR_DONATION' ||
                          item.discount_type === 'MONEY_REDUCTION_OR_DONATION'
                        "
                      >
                        hoặc
                      </p>
                      <p
                        class="mb-1"
                        v-if="
                          item.discount_type === 'ITEM_DONATION' ||
                          item.discount_type === 'PERCENTAGE_DONATION' ||
                          item.discount_type === 'PERCENTAGE_OR_DONATION' ||
                          item.discount_type === 'MONEY_REDUCTION_DONATION' ||
                          item.discount_type === 'MONEY_REDUCTION_OR_DONATION'
                        "
                      >
                        <span
                          class="d-block mb-1"
                          v-if="item.item_donation_type === 'OR'"
                          >Tặng 1 trong các hàng hoá dưới đây</span
                        >
                        <span
                          class="d-block"
                          v-if="item.item_donation_type === 'AND'"
                          >Tặng tất cả các hàng hoá dưới đây</span
                        >
                        <span
                          class="d-block font-italic"
                          v-for="gift in item.item_donation_id.split(',')"
                          :key="gift"
                        >
                          - {{ gift }}
                        </span>
                      </p>
                    </td>
                    <td>
                      <p class="mb-1">{{ formatDate(formData.date[0]) }}</p>
                      <span class="d-block">{{
                        formatDate(formData.date[1])
                      }}</span>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </form>
      <footer class="modal-footer px-0 pb-0">
        <button
          v-if="step === 1"
          type="button"
          class="btn btn-primary"
          @click="onCheckFile"
          :disabled="isLoadingCheck"
        >
          <template v-if="isLoadingCheck">
            <i class="bx bx-loader bx-spin font-size-16 align-middle mr-2"></i>
            Đang xử lý...
          </template>
          <template v-else>Tiếp tục</template>
        </button>
        <button
          v-if="step === 2 && listSuccess.length > 0"
          type="button"
          class="btn btn-primary ml-2"
          @click="onImport"
          :disabled="isLoadingCheck"
        >
          <template v-if="isLoadingCheck">
            <i class="bx bx-loader bx-spin font-size-16 align-middle mr-2"></i>
            Đang xử lý...
          </template>
          <template v-else>Import</template>
        </button>
      </footer>
    </b-modal>
  </Layout>
</template>
